import DestructableObject from "./DestructableObject";

export default class DestructableSet<T> extends DestructableObject implements Set<T> {
	private readonly set = new Set<T>();

	constructor(private readonly persistant = true) {
		super();
	}

	delete(key: T): boolean {
		const result = this.set.delete(key);
		if (!this.persistant && this.size === 0) {
			this.destroy();
		}
		return result;
	}

	clear(): void {
		this.set.clear();
		if (!this.destroyed && !this.persistant) {
			this.destroy();
		}
	}

	has(value: T): boolean {
		return this.set.has(value);
	}
	add(value: T): this {
		this.set.add(value);
		return this;
	}
	get size(): number {
		return this.set.size;
	}
	entries(): IterableIterator<[T, T]> {
		return this.set.entries();
	}
	[Symbol.iterator](): IterableIterator<T> {
		return this.set[Symbol.iterator]();
	}
	forEach(callbackfn: (value: T, value2: T, set: Set<T>) => void, thisArg?: any): void {
		return this.set.forEach(callbackfn, thisArg);
	}
	keys(): IterableIterator<T> {
		return this.set.keys();
	}
	values(): IterableIterator<T> {
		return this.set.values();
	}
	destroy(): void {
		super.destroy();
		this.set.clear();
	}

	get [Symbol.toStringTag](): string {
		return "DestructableSet";
	}
}
